@if (attachments.length > 0) {
  <ul class="attachment-strip" [attr.aria-label]="attachments.length + ' attached image(s)'">
    @for (attachment of attachments; track attachment.attachmentId) {
      <li class="attachment-item" [class.unavailable]="isUnavailable(attachment)">
        <button
          type="button"
          class="attachment-thumb"
          [attr.aria-label]="thumbnailLabel(attachment)"
          [matTooltip]="thumbnailLabel(attachment)"
          (click)="openPreview(attachment)"
        >
          @if (hasPreview(attachment)) {
            <img [src]="previewUrl(attachment)" alt="" aria-hidden="true" class="thumb-image" />
          } @else if (isUnavailable(attachment)) {
            <mat-icon class="thumb-placeholder" aria-hidden="true">broken_image</mat-icon>
          } @else {
            <mat-icon class="thumb-placeholder" aria-hidden="true">image</mat-icon>
          }

          @if (attachment.state === 'uploading' || attachment.state === 'validating') {
            <span class="thumb-progress">
              <mat-progress-bar
                [mode]="attachment.state === 'validating' ? 'indeterminate' : 'determinate'"
                [value]="attachment.progress || 0"
              ></mat-progress-bar>
            </span>
          }

          @if (isUnavailable(attachment)) {
            <span class="thumb-badge" aria-hidden="true">
              <mat-icon>error_outline</mat-icon>
            </span>
          }
        </button>

        @if (removable) {
          <button
            type="button"
            mat-icon-button
            class="attachment-remove"
            [attr.aria-label]="'Remove ' + label(attachment)"
            matTooltip="Remove image"
            (click)="remove(attachment, $event)"
          >
            <mat-icon>close</mat-icon>
          </button>
        }

        <span class="attachment-caption">
          <span class="attachment-name">{{ label(attachment) }}</span>
          @if (isUnavailable(attachment)) {
            <span class="attachment-error" [title]="attachment.failureReason || 'Not attached'">
              {{ attachment.failureReason || 'Not attached' }}
            </span>
          } @else if (attachment.state === 'uploading') {
            <span class="attachment-meta">Uploading {{ attachment.progress || 0 }}%</span>
          } @else if (attachment.state === 'validating') {
            <span class="attachment-meta">Checking image…</span>
          } @else if (details(attachment)) {
            <span class="attachment-meta">{{ details(attachment) }}</span>
          }
          @if (attachment.pageRegion; as region) {
            <button
              type="button"
              class="attachment-source"
              data-testid="attachment-page-region-source"
              [attr.aria-label]="sourceAriaLabel(attachment)"
              [matTooltip]="sourceLabel(attachment)"
              (click)="openSource(attachment, $event)"
            >
              <mat-icon aria-hidden="true">highlight_alt</mat-icon>
              <span>{{ sourceLinkText(attachment) }}</span>
            </button>
          }
        </span>
      </li>
    }
  </ul>
}
